<template>
    <div class="modal-backdrop">
        <div class="card col-lg-4 col-md-8 mt-md-4 col-11 p-0">
            <div class="modal-content postmodalcontent">
                <div class="modal-body bodymodal11">
                    <div class="p-4 text-center">
                        <div class="text-center">
                            <span class="fontsize16 black60 proximanova stylebold">Do you want to save it as a draft ???</span>
                        </div>
                        <div class="d-flex justify-content-center mt-4">
                            <button class="btn button-cancel11 mr-2 navtoPage borderradius20 proximanova" @click="close">Cancel</button>
                            <img src="../../assets/uploadvideo.svg" alt="uploading" width="32px" class="img-fluid ml-3" v-if="saveBtnClicked">
                            <button class="btn sign-up-button blackbackhroundsignin borderradius20 fontsizemd proximanova" v-if="!saveBtnClicked" @click="saveJobAsaDraft">Draft</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
import httpjob from "@/js/http-postjob.js"
import router from '../../router.js'
export default{
   data() {
    return{
      saveBtnClicked : false
    }
  },
  props : [
        'JobObject'
    ],
  methods:{
    close() {
        this.$emit('closeCancelModal', "cancel" );
    },
    // this will invoke after click on draft button 
        // to save data as draft
    saveJobAsaDraft(){
      this.saveBtnClicked = true;
      var vm = this;
        // console.log("save as a draft : ", this.JobObject)
        let finalObj = {
          jobId : this.JobObject.jobId,
          companyProfileId : this.JobObject.companyProfileId,
          employeeId : this.JobObject.employeeId,
          employmentTypeId : this.JobObject.selectedEmploymentType,
          titleId : this.JobObject.titleId,
          jobTitle : this.JobObject.jobTitle,
          jobDesc : this.JobObject.jobDescription,
          seniorityId : this.JobObject.selecetdSeniority,
          jobStatus : 'DRAFT',
          payScaleFrom : this.JobObject.selectedPayScaleFrom,
          payScaleTo : this.JobObject.selectedPayScaleTo,
          countryId : this.JobObject.country,
          stateId : this.JobObject.state,
          cityId : this.JobObject.city,
          zipcode : this.JobObject.pinCode,
          companyBenefitsList : this.JobObject.companyBenefitsList,
          addedSkillsList : this.JobObject.addedSkillsList,
          communicationType : this.JobObject.communicationType,
          emailId : this.JobObject.emailId,
          jobActive : 'ACTIVE',
          screeningQuestionsList : this.JobObject.screeningQuestionsList,
          jobPostedBy : this.JobObject.jobPostedBy
        }
        console.log("final job object : ", finalObj)
        httpjob.post('/postjob/PostingUserInfo', finalObj)
        .then((response) => {
          console.log(response)
          this.saveBtnClicked = false;
          vm.$toast.success("Successfully saved as a draft")
          router.push({
            name : 'draftJobs'
          })
        }).catch((e) => {
          console.log(e.response)
          this.saveBtnClicked = false;
        })
    }
  },
   mounted() {
    console.log("jobobejct : ", this.JobObject)
  },

}

</script>

<style scoped>
.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}
.card {
    padding: -5px !important;
}
label input[type="radio"]:checked ~ span {
    color: #007AFF;
}
.postmodalcontent{
  border: none !important;
}
.btn:focus{
  box-shadow: none;
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
.modal-header{
  border: none;
}
.bodymodal11{
  padding: 0 4% !important;
  /* // height: 200px; */
  overflow-y: auto;
  /* .row{
    margin: -15px;
  } */
}
.close{
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
@media screen and  (max-width : 600px){
  .card{
    margin-left: 4%;
    margin-top: 4%;
  }
}
@media screen and  (min-width: 770px){
  .card{
    margin-left: 35%;
    margin-top: 10% !important;
  }
}
@media screen and  (min-width: 600px) and (max-width : 768px){
  .card{
    margin-left: 15%;
  }
}
</style>